import { Box, Breakpoint, Grid } from '@mui/material';
import { layoutConfig } from 'src/common/layout/config';
import SupportButton from 'src/components/SupportButton';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import { AppSubdomains } from 'src/types/common';
import { getSubdomain } from 'src/utils/domain/getSubdomain';

interface HeaderSupportButtonProps {
  columns?: { [key in Breakpoint]?: number };
}

const DEFAULT_COLUMNS = {
  xs: 12,
  md: 2,
  xl: 2,
};

export default function HeaderSupportButton({
  columns,
}: HeaderSupportButtonProps) {
  const { user } = useAuthContext();
  const hasSelectedAddress = !!user?.main_address?.pk;
  const subdomain = getSubdomain(AppSubdomains, AppSubdomains.Pari);
  const { defaultLayout } = layoutConfig[subdomain];

  return (
    <Grid item {...(columns ?? DEFAULT_COLUMNS)}>
      {defaultLayout.supportButton && (
        <Box position="absolute" top={hasSelectedAddress ? 20 : 8} right={10}>
          <SupportButton variant="icon" size="medium" />
        </Box>
      )}
    </Grid>
  );
}
